//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setting_obj } from '~/settings/setting';
import { needXssKeys } from '~/utils/constants';
import { replaceToOriginStr, formatPath } from '@/utils/tools';
import statusComp from '@/components/card/status.vue';

const statusObj = {
  1: {
    text: '审核中',
    class: 'processing',
  },
  2: {
    text: '审核未通过',
    class: 'failed',
  },
};
export default {
  components: { statusComp },
  props: {
    cardType: {
      type: String,
      default: 'feed',
    },
    showMask: {
      type: Boolean,
      default: false,
    },
    resourceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    action_position: {
      type: String,
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['search', 'community', 'profile', 'banner'].indexOf(value) !== -1;
      },
      default: 'community',
    },
    action_type: {
      type: String,
      default: '',
    },
    action_detail: {
      type: Number,
    },
  },
  data() {
    return {
      imageCdnPath: setting_obj.imageCdnPath,
    };
  },
  computed: {
    formateResourceInfo() {
      const info = { ...this.resourceInfo };
      info.start_time = info.start_time.split('T')[0].replace(/-/g, '.');
      info.end_time = info.end_time.split('T')[0].replace(/-/g, '.');
      info.act_status += '';
      const keys = Object.keys(info).filter((key) => needXssKeys.includes(key));
      keys.forEach((key) => {
        if (!info[key]) return;
        if (Array.isArray(info[key])) {
          info[key] = info[key].map(replaceToOriginStr);
        } else if (typeof info[key] === 'string') {
          info[key] = replaceToOriginStr(info[key]);
        }
      });
      return info;
    },
    statusObj() {
      return statusObj[this.formateResourceInfo.status];
    },
    isShowView() {
      return this.cardType !== 'like' && !this.showMask;
    },
    isShowAuthor() {
      return this.cardType === 'feed';
    },
    coverUrl() {
      const { cover_url } = this.formateResourceInfo;
      const path = formatPath(cover_url, setting_obj.imageCdnPath);
      return path;
    },
  },
  methods: {
    goResourceDetail() {
      const path = `${location.origin}/community/activity/detail?id=${this.formateResourceInfo.act_id}`
      window.open(path, '_blank')
      this.$emit('handelSubs');
    },
    goUser() {
      const routeData = this.$router.resolve({
        name: 'profile-id',
        params: { id: this.formateResourceInfo.author_id },
      });
      window.open(routeData.href, '_blank');
    },
    clickResource(e) {
      if (this.showMask) e.preventDefault();
    },
  },
};
